// This file is auto-generated by localize-js, do not make edits to this file directly
import { TranslatedStringTableFetcher, getStringProvider } from '@fluidx/localize-js';

export interface DiscoverStrings {
  /**
  * Text for loading
  *
  * @defaultValue "Loading..."
  */
  loading: string;
  /**
  * Text for no result in search
  *
  * @defaultValue "No result"
  */
  noResult: string;
  /**
  * Text for search
  *
  * @defaultValue "Search"
  */
  search: string;
  /**
  * search box label text
  *
  * @defaultValue "Search for a component, and navigate the menu below."
  */
  searchBoxAriaLabel: string;
  /**
  * Aria label for div that contains discover menu.
  *
  * @defaultValue "discover menu list"
  */
  discoverMenuAriaLabel: string;
  /**
  * Aria label for List element in Discover component.
  *
  * @defaultValue "Discover Menu"
  */
  discoverMenuListLabel: string;
}

export async function getDiscoverStrings(translatedStringTableFetcher: TranslatedStringTableFetcher, locale: string): Promise<DiscoverStrings> {
  const stringTableJson = await translatedStringTableFetcher(locale);
  return getStringProvider<DiscoverStrings>(stringTableJson, locale);
}
